import { render } from "./OverOnsView.vue?vue&type=template&id=59b37bb1"
import script from "./OverOnsView.vue?vue&type=script&lang=js"
export * from "./OverOnsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__